// We only need to import the modules necessary for initial render
import GeneralLayout from '../layouts/GeneralLayout'
import * as CONFIG from '../config'
import Home from './Home'
import LoginRoute from './Login'
import ManageUsersRoute from './ManageUsers'
import DashboardRoute from './Dashboard'

/*  Note: Instead of using JSX, we recommend using react-router
    PlainRoute objects to build route definitions.   */

export const createRoutes = (store) => ({
  path        : CONFIG.BASE_ROUTE,
  component   : GeneralLayout,
  indexRoute  : Home,
  childRoutes : [
    LoginRoute(store),
    ManageUsersRoute(store),
    DashboardRoute(store),
    {
      path: 'empty',
      component: null,
      key: 'empty'
    }
  ]
})

/*  Note: childRoutes can be chunked or otherwise loaded programmatically
    using getChildRoutes with the following signature:

    getChildRoutes (location, cb) {
      require.ensure([], (require) => {
        cb(null, [
          // Remove imports!
          require('./Counter').default(store)
        ])
      })
    }

    However, this is not necessary for code-splitting! It simply provides
    an API for async route definitions. Your code splitting should occur
    inside the route `getComponent` function, since it is only invoked
    when the route exists and matches.
*/

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js